import React, { useEffect, useState } from "react";
import HomeService from "../../services/KangarooServices/HomeServices";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Badge,
} from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { Edit3 } from "lucide-react";
import { imageBaseApi } from "../../utilis/imageHelper";

const HomeSectionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async (id) => {
    try {
      setLoading(true);
      const result = await HomeService.getdetails(id);
      setData(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchDetail(id);
  }, [id]);

  if (loading) {
    return (
      <div className="page-content">
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "70vh" }}
        >
          <div className="text-center">
            <Spinner color="primary" />
            <p className="mt-3 text-muted fw-medium">Loading details...</p>
          </div>
        </Container>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="page-content">
        <Container fluid>
          <Card className="border-0 shadow-sm text-center p-5">
            <CardBody>
              <h4 className="text-danger">No Data Found</h4>
              <p className="text-muted">
                The requested section could not be retrieved.
              </p>
              <Button
                color="primary"
                outline
                onClick={() => navigate("/homesection")}
              >
                Return to List
              </Button>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content bg-light-subtle">
      <Container fluid>
        <BreadCrumb
          title="Section Details"
          pageTitle="Home"
          breadcrumbItems={[{ title: "Back to List", link: "/homesection" }]}
        />

        <Row className="m-0">
          <Col lg={12} xl={12}>
            <Card className="border-0 shadow-lg overflow-hidden rounded-4">
              <Row className="g-0">
                <Col
                  md={4}
                  className="bg-dark d-flex align-items-center border-end"
                >
                  {data.media?.url ? (
                    <img
                      src={`${imageBaseApi}${data.media.url}`}
                      alt={data.sectionName}
                      className="img-fluid w-100 h-100"
                      style={{ objectFit: "cover", minHeight: "500px" }}
                    />
                  ) : (
                    <div className="w-100 text-center text-white-50 p-5">
                      <p className="mb-0">No Preview Image</p>
                    </div>
                  )}
                </Col>

                <Col md={8}>
                  <CardBody className="p-4 p-md-5 h-100 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-4">
                      <div>
                        <Badge
                          color="primary"
                          className="mb-2 px-3 py-2 bg-primary-subtle text-primary border border-primary-subtle text-uppercase"
                        >
                          Home Section Detail
                        </Badge>
                        <h1 className="display-6 fw-bold text-dark mb-0">
                          {data.sectionName}
                        </h1>
                      </div>
                      <Button
                        color="primary"
                        className="d-flex align-items-center gap-2 px-4 shadow-sm"
                        onClick={() =>
                          navigate(`/homesection-form/${data?.id}`)
                        }
                      >
                        <Edit3 size={16} /> Edit
                      </Button>
                    </div>

                    <hr className="my-4 opacity-25" />

                    <Row className="g-3 mb-4">
                      <Col sm={6} lg={4}>
                        <div className="p-3 border-0 bg-light rounded-3 h-100">
                          <small
                            className="text-muted d-block mb-1 text-uppercase fw-bold"
                            style={{
                              fontSize: "0.65rem",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Slug Reference
                          </small>
                          <p className="mb-0 fw-semibold text-dark">
                            {data.slug}
                          </p>
                        </div>
                      </Col>
                      <Col sm={6} lg={4}>
                        <div className="p-3 border-0 bg-light rounded-3 h-100">
                          <small
                            className="text-muted d-block mb-1 text-uppercase fw-bold"
                            style={{
                              fontSize: "0.65rem",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Display Order
                          </small>
                          <p className="mb-0 fw-semibold text-dark">
                            Position #{data.orderIndex}
                          </p>
                        </div>
                      </Col>
                      <Col sm={12} lg={4}>
                        <div className="p-3 border-0 bg-light rounded-3 h-100">
                          <small
                            className="text-muted d-block mb-1 text-uppercase fw-bold"
                            style={{
                              fontSize: "0.65rem",
                              letterSpacing: "0.5px",
                            }}
                          >
                            Call to Action
                          </small>
                          <p className="mb-0 fw-semibold text-dark">
                            {data.buttonText || "No Label"}
                          </p>
                        </div>
                      </Col>
                    </Row>

                    <div className="flex-grow-1">
                      <h6 className="text-uppercase fw-bold text-muted small mb-3">
                        Content Description
                      </h6>
                      <div
                        className="p-3 border border-light-subtle rounded-3 bg-white"
                        style={{ lineHeight: "1.8", color: "#495057" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            data.description || "No description provided.",
                        }}
                      />
                    </div>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomeSectionDetail;
